<kt-portlet class="kt-portlet--height-fluid w-100" *ngIf="(page$ | async)?.showTitle">
  <kt-portlet-header [title]="title$ | async"></kt-portlet-header>
  <kt-portlet-body [innerHtml]="content$ | async"></kt-portlet-body>
</kt-portlet>

<div class="content" *ngIf="!(page$ | async)?.showTitle" [innerHTML]="content$ | async"></div>
